/**
 * 其他项目添加组件：可自行添加自定义组件
 */

export default {
  // 图纸自定义组件
  Map: [
    // 示例
  ],
  // 模型自定义组件
  Model: [
    // {
    //   id: 'globe',
    //   cnName: '地图',
    //   icon0: require('./modelProMax/images/地图.png'),
    //   icon1: require('./modelProMax/images/地图s.png'),
    //   button: 'bottom',
    //   key: 'right',
    //   type:'model',
    //   component: null
    // },
  ],
  // 模型图纸自定义组件
  ModelMap: [

  ],
  // office,pdf,IMG,TXT自定义组件
  Other: [

  ]
};
